module.exports = __webpack_public_path__ + "img/light.4183aad0.svg";